/* eslint-disable @typescript-eslint/no-explicit-any */
export const createStringUrl = (baseUrl: string, urlParams: Record<string, unknown>) => {
  const queryKeys = Object.keys(urlParams);

  if (queryKeys.length === 0) {
    return baseUrl;
  }

  const concatedParams = queryKeys.reduce((queryString, queryKey) => {
    const value = urlParams[queryKey];

    if (value) {
      const keyValueString = `${queryKey}=${value}`;
      return queryString ? `${queryString}&${keyValueString}` : keyValueString;
    }

    return queryString;
  }, "");

  return `${baseUrl}?${concatedParams}`;
};

export const replaceAccents = (input?: string) => {
  if (!input) {
    return "";
  }

  /* Normalize the string to remove diacritics (accents) */
  const sanitized = input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  return sanitized;
};

type AnyObject = { [key: string]: any };

export function hasEmptyStringProperty(obj: AnyObject): boolean {
  for (const key in obj) {
    if (typeof obj[key] === "string" && obj[key].trim() === "") {
      return true;
    }
  }
  return false;
}

export function sanitizeText(txt: string): string {
  return txt
    .trim()
    .toLowerCase()

    .replace(/r\$|\br\$|\b/gi, "")

    .replace(/(\d+)[.,]\d{2}/g, "$1")
    .replace(/\s+/g, " ")
    .replace(/,/g, "")
    .replace(/\s+/g, "_")
    .replace(/[\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, "a")
    .replace(/[\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, "e")
    .replace(/[\u00ed\u00ec\u00ee\u00ef]/g, "i")
    .replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8\u00ba]/g, "o")
    .replace(/[\u00fa\u00f9\u00fb\u00fc]/g, "u")
    .replace(/[\u00e7\u00a2\u00a9]/g, "c")
    .replace(/[?!*;:.,'`´^~ªº()+=&¨%$#@"“”|<>[\]{}\\/]/g, "")
    .replace(/-+/g, "_");
}
